import React, { useEffect } from "react";
import Webabout from "./Webabout";
import Websolution from "./Websolution";
import Webfeatures from "./Webfeatures";
import Webcards from "./Webcards";
import Mobileautobanner from "./Mobileautobanner";

const Mobileautomation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Mobileautobanner/>
      <Webabout/>
      <Websolution />

      <Webfeatures/>
      <Webcards/>
    </div>
  );
};

export default Mobileautomation;
